import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const OximoWidgetPage = () => {
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "oximo" && event.data.param === "height") {
        const iframe = document.getElementById("oximo-iframe");
        if (iframe) {
          // Ensure value is in px
          const height = typeof event.data.value === "number" 
            ? `${event.data.value}px` 
            : event.data.value;

          iframe.style.height = height;
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div>
      <Navbar />
      <Container style={{ maxWidth: "100%", padding: 0 }}>
        <div
          style={{
            width: "100%",
            minHeight: "300vh",
            overflowY: "auto",
          }}
        >
          <iframe
            id="oximo-iframe"
            style={{
              width: "100%",
              border: "none",
              minHeight: "300vh",
              marginBottom: "100px",
              display: "block",
            }}
            src="https://www.oximo.pl/widget/?HTTP_REFERER=https://kamsiparts.com/"
            title="Oximo Widget"
          />
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default OximoWidgetPage;
